import React from 'react';
import Layout from '../../components/Layout';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { CheckCircle, Package, ArrowRight } from 'lucide-react';

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get('order_id');

  return (
    <Layout>
      <div className="max-w-lg mx-auto py-12" data-testid="checkout-success-page">
        <div className="text-center space-y-5" data-testid="status-paid">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Payment Successful!</h1>
          <p className="text-slate-500">Thank you for your order. Your filters are on the way!</p>
          {orderId && (
            <div className="bg-green-50 border border-green-200 rounded-xl px-5 py-4 text-left" data-testid="order-confirmation">
              <div className="flex items-center gap-2 mb-2">
                <Package className="h-4 w-4 text-green-600" />
                <span className="text-xs font-bold text-green-700 uppercase tracking-wider">Order Confirmed</span>
              </div>
              <p className="text-sm text-green-800 font-mono font-bold">{orderId}</p>
              <p className="text-xs text-green-600 mt-1">You'll receive delivery tracking updates on your orders page.</p>
            </div>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
            <Button onClick={() => navigate('/customer/orders')}
              className="bg-gradient-to-r from-sky-500 to-teal-500 hover:from-sky-600 hover:to-teal-600 text-white font-bold"
              data-testid="view-orders-btn">
              View My Orders <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
            <Button variant="outline" onClick={() => navigate('/customer/new-order')} data-testid="order-again-btn">
              Order More Filters
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CheckoutSuccess;
